import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { ListaReceitasDespesasResponseDTO, TotalMoedaDTO } from '../../models/dashboard/lista-receitas-despesas.model';

@Injectable({ providedIn: 'root' })
export class ContasAPagarService {

  constructor(private apiService: ApiService) {}

  listarDespesas(params: {
    page: number;
    size?: number;
    conta?: number;
    dataInicio?: string;
    dataFim?: string;
    tipoDespesa?: string;
    pessoaId?: number;
    observacao?: string;
    sort?: string;
  }): Observable<ListaReceitasDespesasResponseDTO> {
    const parts: string[] = [`page=${params.page}`];
    if (params.size) parts.push(`size=${params.size}`);
    if (params.conta) parts.push(`conta=${params.conta}`);
    if (params.dataInicio) parts.push(`dataInicio=${params.dataInicio}`);
    if (params.dataFim) parts.push(`dataFim=${params.dataFim}`);
    if (params.tipoDespesa) parts.push(`tipoDespesa=${params.tipoDespesa}`);
    if (params.pessoaId) parts.push(`pessoaId=${params.pessoaId}`);
    if (params.observacao) parts.push(`observacao=${params.observacao}`);
    if (params.sort) parts.push(`sort=${params.sort}`);

    const query = parts.join('&');
    return this.apiService.read<ListaReceitasDespesasResponseDTO>(
      `/totaldashboard/listarDespesasPorFiltros?${query}`
    );
  }

  buscarTotais(params: {
    conta?: number;
    dataInicio?: string;
    dataFim?: string;
    tipoDespesa?: string;
    pessoaId?: number;
    observacao?: string;
  }): Observable<TotalMoedaDTO> {
    const parts: string[] = [];
    if (params.conta) parts.push(`conta=${params.conta}`);
    if (params.dataInicio) parts.push(`dataInicio=${params.dataInicio}`);
    if (params.dataFim) parts.push(`dataFim=${params.dataFim}`);
    if (params.tipoDespesa) parts.push(`tipoDespesa=${params.tipoDespesa}`);
    if (params.pessoaId) parts.push(`pessoaId=${params.pessoaId}`);
    if (params.observacao) parts.push(`observacao=${params.observacao}`);

    const query = parts.length ? `?${parts.join('&')}` : '';
    return this.apiService.read<TotalMoedaDTO>(
      `/totaldashboard/total-despesas${query}`
    );
  }
}
